// @flow strict

import { string, object, type Schema, boolean } from 'yup';
import { type FormValue } from './types';

export const validationSchema: Schema<FormValue, any> = object().shape({
  firstName: string()
    .trim()
    .required('First name is required'),
  lastName: string()
    .trim()
    .required('Last name is required'),
  phoneNumber: string()
    .trim()
    .required('Phone number is required'),
  locationId: string().required('City is required'),
  isSso: boolean().required(),
  password: string().when(['isSso', 'signUpCompleted'], {
    is: false,
    then: string().required('Password is required'),
    otherwise: string().required('Password is required'),
  }),
  termsAndConditionsAccepted: boolean().oneOf([true]),
});

export const passwordOnlyValidationSchema: Schema<FormValue, any> = object().shape({
  firstName: string(),
  lastName: string(),
  phoneNumber: string(),
  locationId: string(),
  isSso: boolean(),
  password: string()
    .trim()
    .required('Password is required'),
  termsAndConditionsAccepted: boolean().oneOf([true]),
});

export const getValidateSchema = (isProfileExists: boolean) => {
  if (isProfileExists) {
    return passwordOnlyValidationSchema;
  }

  return validationSchema;
};
